import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import config from '../config';
import { postRequest } from '../utils/api';

const Acknowledge: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [message, setMessage] = useState<string>('Acknowledging incident...');

  useEffect(() => {
    acknowledgeIncident();
  }, [id]);

  const acknowledgeIncident = async () => {
    try {
      const response = await postRequest(
        `${config.apiBaseUrl}/incidents/${id}/acknowledge`,
      );

      setMessage('The incident has been acknowledged.');
    } catch (error) {
      setMessage(`${error}`);
    }
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '20px' }}>
      <h2>{message}</h2>
    </div>
  );
};

export default Acknowledge;
